import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {ResolveDispatchProps} from '../../../helpers/reduxHelpers';
import {CrmSyncSourcesEnum} from '../../../models/api/crmSyncModel';
import {AppState} from '../../../store/appState';
import {toggleExpandItemAction} from '../../../store/data/localPreferences/localPreferencesActions';
import {getFindIsExpanded} from '../../../store/data/localPreferences/localPreferencesSelectors';
import {getIsUserGlobalAdmin} from '../../../store/data/teammates/teammatesSelectors';
import {CrmSyncDialog} from './crmSyncDialog';

/*
 * Constants.
 */

const isInfoBoxExpandedDefault = true;

/*
 * Props.
 */

interface CrmSyncDialogContainerProps {
  source: CrmSyncSourcesEnum;
}

/*
 * Selectors.
 */

function getSource(_state: AppState, props: CrmSyncDialogContainerProps) {
  return props.source;
}

function makeGetIsInfoBoxExpanded() {
  return createSelector([getSource, getFindIsExpanded], (source, findIsExpanded) =>
    findIsExpanded(buildInfoBoxKey(source), isInfoBoxExpandedDefault),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmSyncDialogContainerProps>()(() => ({
  isInfoBoxExpanded: makeGetIsInfoBoxExpanded(),
  isAdmin: getIsUserGlobalAdmin,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onToggleInfoBox: (infoBoxKey: string) => toggleExpandItemAction(infoBoxKey, isInfoBoxExpandedDefault),
}));

const mergeProps = (
  stateProps: ResolveStateProps<typeof mapStateToProps>,
  dispatchProps: ResolveDispatchProps<typeof mapDispatchToProps>,
  ownProps: CrmSyncDialogContainerProps,
) => {
  const {source} = ownProps;
  const {onToggleInfoBox} = dispatchProps;

  return {
    ...stateProps,
    onToggleInfoBox: () => onToggleInfoBox(buildInfoBoxKey(source)),
    ...ownProps,
  };
};

export const CrmSyncDialogContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CrmSyncDialog);

/*
 * Helpers.
 */

function buildInfoBoxKey(source: CrmSyncSourcesEnum) {
  return `${source}-crm-dialog-infoBox`;
}
